import { NavLink } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/Card';
import { icons } from '../components/ui/Icons';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-50 px-4 py-10 dark:bg-neutral-950">
      <Card className="w-full max-w-md text-center">
        <CardHeader className="flex flex-col items-center">
          <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-md bg-neutral-100 text-neutral-600 dark:bg-neutral-800 dark:text-neutral-300">
            <icons.Search className="h-7 w-7" aria-hidden="true" />
          </div>
          <CardTitle className="text-3xl">404</CardTitle>
          <CardDescription className="mt-2 text-base">Seite nicht gefunden</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <p className="text-sm leading-6 text-neutral-600 dark:text-neutral-300">
            Die gesuchte Seite existiert nicht oder wurde verschoben. Bitte überprüfen Sie die URL oder kehren Sie zur Startseite zurück.
          </p>
          <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
            <Button onClick={() => window.history.back()} variant="outline" leftIcon="ArrowLeft">
              Zurück
            </Button>
            <NavLink to="/" className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:bg-primary-500 dark:hover:bg-primary-600">
              <icons.Home className="h-4 w-4" aria-hidden="true" />
              Startseite
            </NavLink>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
